export const useListOfAuthors = (
  listOfAuthors: string[],
  maxCount: number
): { readableListOfAuthors: string } => {
  const uniqueAuthorNames = [...new Set(listOfAuthors)];
  const countAuthorNames = uniqueAuthorNames.length;
  const countOthers = uniqueAuthorNames.length - maxCount;
  const readableListOfAuthors =
    countAuthorNames < maxCount
      ? uniqueAuthorNames.join(', ')
      : uniqueAuthorNames.slice(0, maxCount).join(', ') +
        `${
          countOthers > 0
            ? ` + ${countOthers === 1 ? '1 other' : `${countOthers} others`}`
            : ''
        }`;
  return {
    readableListOfAuthors,
  };
};
